export default __webpack_public_path__ + "static/media/demo-6.97420653.png";